// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bic_tr","LeftMenu__link":"ir_b bic_vt bic_a bic_rc","LeftMenu__link__icon":"ir_c"};